export default {
    common: {
        title: "Modifier l'image",
        cancel: 'Cnnuler',
        save: 'Enregistrer',
        crop: 'Recadrer',
        adjustments: 'Les ajustements',
        filters: 'Filtres',
        frames: 'Verres ',
        overlays: 'Superpositions',
        text: 'Texte',
        stickers: 'Autocollants',
        brush: 'Brosse',
        ai: "Créer une image en utilisant l'intelligence artificielle",
        reset: 'Réinitialiser',
        comingSoon: 'Prochainement...',
        apply: 'Appliquer',
        undo: 'Annuler',
        redo: 'refaire',
        flipHorizontal: 'Retourner horizontalement',
        flipVertical: 'Retourner Verticalement',
        rotateClockwise: "Tourner dans le sens des aiguilles d'une montre",
        rotateAntiClockwise: "Tourner dans le sens contraire des aiguilles d'une montre",
        warning: 'Attention',
        discard: 'se débarrasser',
        continue: "Continuer l'édition",
        discardHeading: 'Abandonnez vos modifications?',
        discardSubHeading: "Si vous fermez l'éditeur d'images, vos modifications ne seront pas enregistrées",
        subtitle: "Les formats d'image pris en charge sont le PNG et le JPEG",
        clone: 'Cloner',
        delete: 'Supprimer',
    },
};
